import { getLocaleFromPath, Locale } from "../i18n/config";
import { REGIONS, RegionCode } from "./constants";

const DEFAULT_REGION_BY_LOCALE: Record<Locale, RegionCode> = {
    fi: "FI",
    en: "EN-GLOBAL",
    sv: "SE",
};

const ALLOWED_REGION_BY_LOCALE: Record<Locale, Set<RegionCode>> = {
    fi: new Set<RegionCode>(["FI", "FI-SV"]),
    en: new Set<RegionCode>(["UK", "IE", "EN-GLOBAL"]),
    sv: new Set<RegionCode>(["SE", "FI-SV"]),
};

export const getBootstrappedRegionCode = (): RegionCode => {
    const locale = getLocaleFromPath(window.location.pathname);
    const persistedRegion = localStorage.getItem("region") as RegionCode | null;
    if (persistedRegion && ALLOWED_REGION_BY_LOCALE[locale].has(persistedRegion)) {
        return persistedRegion;
    }
    return DEFAULT_REGION_BY_LOCALE[locale];
};

export const getDisplayRegion = (regionCode: string | undefined, pathname?: string) => {
    const currentPath = pathname ?? window.location.pathname;
    const regionFromState = REGIONS.find((r) => r.code === regionCode);
    if (currentPath.startsWith("/admin") && regionFromState) return regionFromState;
    const locale = getLocaleFromPath(currentPath);
    if (regionFromState?.lang === locale) return regionFromState;
    return REGIONS.find((r) => r.lang === locale) ?? REGIONS[0];
};
